import React, { useState } from 'react';
import { FaTimes } from 'react-icons/fa';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [
    `${process.env.PUBLIC_URL}/assets/g1.png`,
    `${process.env.PUBLIC_URL}/assets/lux_rooms.png`,
    `${process.env.PUBLIC_URL}/assets/story_bed.png`,
    `${process.env.PUBLIC_URL}/assets/restaurant.png`,
    `${process.env.PUBLIC_URL}/assets/g2.png`,
    `${process.env.PUBLIC_URL}/assets/g3.png`,
    `${process.env.PUBLIC_URL}/assets/g4.png`,
    `${process.env.PUBLIC_URL}/assets/g5.png`,
    `${process.env.PUBLIC_URL}/assets/g6.png`,
    `${process.env.PUBLIC_URL}/assets/g7.png`,
    `${process.env.PUBLIC_URL}/assets/fewa.png`,
    `${process.env.PUBLIC_URL}/assets/adventure.png`,
    `${process.env.PUBLIC_URL}/assets/tours.png`,
    `${process.env.PUBLIC_URL}/assets/story_building.png`,
    `${process.env.PUBLIC_URL}/assets/story_room.png`,
    `${process.env.PUBLIC_URL}/assets/triple.png`,
    `${process.env.PUBLIC_URL}/assets/twin.png`,
  ];

  const openLightbox = (image) => {
    setSelectedImage(image);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  return (
    <div className="py-16 bg-highlight">
      <div className="max-w-7xl mx-auto px-4">
        <h1 className="text-4xl font-serif font-bold text-primary text-center mb-12">Gallery</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {images.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`Gallery ${index + 1}`}
              className="w-full h-64 object-cover rounded-xl cursor-pointer hover:opacity-90 hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl"
              onClick={() => openLightbox(img)}
            />
          ))}
        </div>
      </div>

      {selectedImage && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50" onClick={closeLightbox}>
          <div className="relative max-w-4xl max-h-screen p-4">
            <img src={selectedImage} alt="Selected" className="max-w-full max-h-full" />
            <button
              onClick={closeLightbox}
              className="absolute top-0 right-0 m-4 text-white text-2xl hover:text-gray-300"
            >
              <FaTimes />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;